<template>
  <div id="education" class="p-6 flex flex-col sm:flex-row justify-center items-center fhd:space-x-16 dark:bg-dark-code bg-gray-50 w-screen">
    <EducationList />
    <div class="flex flex-col justify-around fhd:justify-end w-full sm:w-2/5 fhd:w-1/4 h-3/5 sm:h-4/5 fhd:h-3/5 sm:self-end fhd:self-center fhd:mt-10">
      <EducationLike />
      <EducationExtras />
    </div>
  </div>
</template>

<script>
import EducationList from './EducationList.vue';
import EducationLike from './EducationLike.vue';
import EducationExtras from './EducationExtras.vue';

export default {
  components: {
    EducationList,
    EducationLike,
    EducationExtras,
  },
}
</script>
